<template>
    <b-list-group-item
        href="javascript:void(0)"
        class="flex-column align-items-start"
        @click="$bvModal.show(modalId)"
        ref="container"
        :style="[index != 0 ? 'border-top: 1px solid rgba(0, 0, 0, 0.125)' : 'border-top: 0px solid #ffffff']"
        style="
            min-width: 300px;
            border-bottom: 0px solid #ffffff;
            border-radius: 0px;
            border-left: 0px;
            border-right: 0px;
            cursor: pointer;
        "
    >
        <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">
                {{ item.subject }} <small class="text-muted text-nowrap">{{ date }}</small>
            </h5>

            <div @mouseover="xHover = true" @mouseleave="xHover = false" style="height: fit-content" @click.stop.prevent="onDismiss()">
                <font-awesome-icon
                    v-if="xHover"
                    :icon="['fas', 'circle-xmark']"
                    class="text-primary"
                    title="Mark as Read"
                ></font-awesome-icon>
                <font-awesome-icon
                    v-else
                    :icon="['far', 'circle-xmark']"
                    class="text-muted"
                    title="Mark as Read"
                ></font-awesome-icon>
            </div>
        </div>
        <div class="mb-1" :class="{ 'text-nowrap': false }">
            {{ item.body.substring(0, 100) }}{{ item.body.length >= 100 ? '...' : '' }}
        </div>
        <notification-modal
            showMarkAsRead
            :subject="item.subject"
            :message="item.body"
            :modalId="modalId"
            :notificationId="item.id.toString()"
            :date="item.date"
            :href="item.href"
        ></notification-modal>
    </b-list-group-item>
</template>

<script>
    import API from '../../../api';
    import { NOTIFICATION_ENDPOINT } from '../../../endpoints';
    import { mapMutations } from 'vuex';
    import { formatDistanceToNowStrict } from 'date-fns';
    import Modal from '../../generic/modal/modal.vue';
    import { NOTIFICATION_DROPDOWN_MAX } from '../../../constants';
    import NotificationModal from '../../notification/notification-modal.vue';

    export default {
        name: 'NotificationMessage',
        props: {
            item: Object,
            index: Number,
        },
        components: {
            Modal,
            NotificationModal,
        },
        computed: {
            date() {
                let date = `${formatDistanceToNowStrict(new Date(this.item.date))} ago`;
                if (date.includes('second')) {
                    date = 'Just now';
                }
                return date;
            },
            modalId() {
                return 'show-message-modal' + this.item.id + 'notification-header' + Math.random();
            },
        },
        methods: {
            ...mapMutations('header', ['setNotificationList']),
            async onDismiss() {
                this.$bvModal.hide(this.modalId);
                await API.patch(`${NOTIFICATION_ENDPOINT()}notifications_set_read/`, {
                    notification_id: this.item.id,
                });
                const notificationList = await API.get(`${NOTIFICATION_ENDPOINT()}notifications/`, {
                    params: {
                        offset: 0,
                        limit: NOTIFICATION_DROPDOWN_MAX,
                        sort: 'date',
                        desc: true,
                        is_read: false,
                    },
                });
                this.setNotificationList(notificationList.data);
            },
        },
        data() {
            return {
                xHover: false,
            };
        },
    };
</script>
